
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/web/part-load-booking",
      function () {
        return require("private-next-pages/web/part-load-booking.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/web/part-load-booking"])
      });
    }
  